import { createFileRoute } from "@tanstack/react-router";
import { ReadingPage } from "@/components/reading/reading-page";
import { readingOverviewQuery } from "@/lib/reading";

export const Route = createFileRoute("/_app/reading")({
  loader: ({ context }) => context.queryClient.prefetchQuery(readingOverviewQuery),
  component: ReadingPage,
});
